import React, { memo } from "react";
import styles from "./styles.module.scss";
import FormItem from "app/components/inputs/FormItem";
import Select from "react-select";
import { SelectStyles } from "app/routes/Calendar/EventForm/constants";
import { useTranslation } from "react-i18next";
import { CoachProfileModel } from "app/models/scheduling/CoachProfileModel";
import SessionsDatePicker from "./_components/SessionsDatePicker";
import { DateTime } from "luxon";
import SessionInputForm from "./_components/SessionInputForm";

interface ILeftPanel {
  date: DateTime;
  handleDecreaseMonth: (decreaseMonth?: () => void) => void;
  handleIncreaseMonth: (increaseMonth?: () => void) => void;
  excludeDates?: Date[];
  handleChangeDate: (value: DateTime) => void;

  coachesList: CoachProfileModel[];
  coach: CoachProfileModel;
  handleCoachChange: (coach: CoachProfileModel) => void;
  lessonRates: any;
  lessonRate: any;
  handleLessonRateChange: (value: number) => void;
}

const LeftPanel = ({
  date,
  handleChangeDate,
  excludeDates,
  handleIncreaseMonth,
  handleDecreaseMonth,
  coachesList,
  coach,
  handleCoachChange,
  lessonRates,
  lessonRate,
  handleLessonRateChange,
}: ILeftPanel) => {
  const { t } = useTranslation();

  return (
    <div className={styles.left_panel}>
      <FormItem className={styles.input_field}>
        <label>{t("Coach")}</label>
        <Select
          styles={SelectStyles}
          options={coachesList}
          value={coach}
          onChange={handleCoachChange}
          isDisabled={coachesList?.length < 2}
          getOptionLabel={(coach) => coach.fullName}
          getOptionValue={(coach) => coach.id}
          isSearchable={false}
        />
      </FormItem>

      <SessionInputForm
        lessonRates={lessonRates}
        lessonRate={lessonRate}
        handleLessonRateChange={handleLessonRateChange}
      />

      <SessionsDatePicker
        date={date}
        handleDecreaseMonth={handleDecreaseMonth}
        handleIncreaseMonth={handleIncreaseMonth}
        excludeDates={excludeDates}
        handleChangeDate={handleChangeDate}
        className={styles.date_picker_desktop}
      />
    </div>
  );
};

export default memo(LeftPanel);
